/* Presentation only. No requests, storage, forms, consent or measurement hooks. */
(() => {
  function init() {
    if (!document.querySelector('[data-bd-legal]')) return;
    const box = document.querySelector('.shopify-policy__container');
    const body = box && box.querySelector('.shopify-policy__body');
    if (!body || box.querySelector('.bd-legal-aside')) return;
    // The policy title is the page H1. Preserve all text and attributes while
    // placing imported document headings at the correct semantic level.
    body.querySelectorAll('h1').forEach(original => {
      const heading = document.createElement('h2');
      Array.from(original.attributes).forEach(a => heading.setAttribute(a.name, a.value));
      while (original.firstChild) heading.append(original.firstChild);
      original.replaceWith(heading);
    });
    const aliases = {
      '/pages/datenschutzbestimmungen': '/policies/privacy-policy',
      '/pages/bedingungen-der-dienstleistung': '/policies/terms-of-service',
      '/pages/ruckgabe-und-erstattungsbedingungen': '/policies/refund-policy',
      '/pages/versandpolitik': '/policies/shipping-policy',
      '/policies/contact-information': '/policies/legal-notice'
    };
    const current = aliases[location.pathname] || location.pathname;
    document.querySelectorAll('.bd-legal-nav a').forEach(a => {
      if (a.getAttribute('href') === current) a.setAttribute('aria-current', 'page');
    });
    const aside = document.createElement('aside');
    aside.className = 'bd-legal-aside';
    const title = document.createElement('p');
    title.className = 'bd-legal-aside__label';
    title.textContent = 'IN DIESEM DOKUMENT';
    aside.append(title);
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Inhaltsverzeichnis dieser Seite');
    const list = document.createElement('ol');
    const headings = Array.from(body.querySelectorAll('h2, h3')).filter(h => h.textContent.trim() !== 'Inhaltsverzeichnis');
    headings.forEach((heading, i) => {
      if (!heading.id) {
        let id = 'bd-legal-abschnitt-' + (i + 1);
        while (document.getElementById(id)) id += '-a';
        heading.id = id;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();
      li.append(a);
      list.append(li);
    });
    if (!headings.length) {
      title.textContent = 'DIREKT ERREICHBAR';
    } else {
      nav.append(list);
      const contents = document.createElement('details');
      contents.className = 'bd-legal-contents';
      const summary = document.createElement('summary');
      summary.textContent = 'In diesem Dokument';
      contents.append(summary, nav);
      const desktop = window.matchMedia('(min-width: 901px)');
      const syncContents = () => { contents.open = desktop.matches; };
      syncContents();
      desktop.addEventListener('change', syncContents);
      aside.append(contents);
    }
    const help = document.createElement('div');
    help.className = 'bd-legal-help';
    const heading = document.createElement('strong');
    heading.textContent = 'Eine Frage offen?';
    const email = document.createElement('a');
    email.href = 'mailto:info@beamdeals.de';
    email.textContent = 'info@beamdeals.de';
    const privacy = document.createElement('a');
    privacy.href = 'mailto:bastert@beamdeals.de';
    privacy.textContent = 'Datenschutzbeauftragten kontaktieren';
    help.append(heading, email);
    if (/privacy|datenschutz|gdpr/.test(location.pathname)) help.append(privacy);
    const print = document.createElement('button');
    print.type = 'button';
    print.textContent = 'Drucken / als PDF speichern';
    print.addEventListener('click', () => window.print());
    help.append(print);
    aside.append(help);
    box.prepend(aside);
    box.classList.add('bd-legal-enhanced');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
